import {createSelector} from 'reselect';

import { TRIAL_PLANS, HIGHER_PLAN_TRIAL_STATE } from '../constants';

const storeAvailableFeatures = (store) => store.userDetails.availableFeatures;
const storePlanDetails = (store) => store.userDetails.planDetails;
const storeUserRole = (store) => store.userDetails.role;
const storeUserProperties = (store) => store.userDetails.userProperties;
export const storeUserDetails = (store) => store.userDetails;

export const currentUserPermissionsSelector = (store) => store.userDetails.userPermissions
export const currentUserEmailIdSelector = (store) => store.userDetails.emailId
export const currentDomainSelector = (store) => store.userDetails.domain
export const currentSharedMailboxUsage = (store) => store.userDetails.sharedMailboxes
export const currentSharedLabelsUsage = (store) => store.userDetails.sharedLabels
export const isAccountSuspendedSelector = (store) => store.userDetails.is_suspended
export const higherPlanTrialInfoSelector = (store) => store.userDetails.ugTrialInfo
export const currentUserSession = (store) => store.appModes.userSession
export const deltaFeaturesSelector = (store) => store.userDetails.ugTrialInfo.delta_features
export const ugTrialInfoSelector = (store) => store.userDetails.ugTrialInfo
export const slaLimitSelector = (store) => store.userDetails.sla
export const customFieldLimitSelector = (store) => store.userDetails.customFields
export const rolesByIdSelector = (store) => store.roles.data.byId
export const ugUsersSelector = (store) => store.usersAndGroups.users
export const queryParamsSelector = (store) => store.appDetails.queryParams;
export const usergroupPropertiesSelector = (store) => store.userDetails.usergroupProperties;

export const availableFeaturesSelector = createSelector(
    storeAvailableFeatures,
     (features) =>  features || []
)

export const currentPlanDetailsSelector = createSelector(
    storePlanDetails,
     (details) =>  details 
)

export const currentUserRoleSelector = createSelector(
    storeUserRole,
     (role) =>  role 
)

export const userPropertiesSelector = createSelector(
    storeUserProperties,
     (properties) =>  properties || {}
)

export const currentUserIdSelector = createSelector(
    storeUserDetails,
    (user) => user.userId
)

export const currentUserGroupIdSelector = createSelector(
    storeUserDetails,
    (user) => user.usergroupId
)

export const currentSmCreationDisabledSelector = createSelector(
    currentSharedMailboxUsage,
    (sharedMailboxUsage) => {
      const { used, total } = sharedMailboxUsage;
      return used && total && used >= total;
    }
);

export const isSlCreationAllowedSelector = createSelector(
    currentSharedLabelsUsage,
    (slUsageDetails) => {
        const { used, total } = slUsageDetails;
        return used < total;
    }
)

export const slUsedSelector = createSelector(
    currentSharedLabelsUsage,
    (slUsageDetails) => {
        const { used } = slUsageDetails;
        return used;
    }
)

export const isAdminSelector = createSelector(
    storeUserRole,
    (userRole) => userRole && userRole.name === 'Admin'
);

export const hasPermissionSelector = createSelector(
    currentUserPermissionsSelector,
    (_, permissionName) => permissionName,
    (userPermissions, permissionName) =>
      userPermissions.some((permission) => permission === permissionName)
  );

export const isTrialUserSelector = createSelector(
    currentPlanDetailsSelector,
    (details) => TRIAL_PLANS.includes(details?.planid)
);

// Returns true if user has an ongoing trial of a higher plan
export const isHigherPlanTrialActiveSelector = createSelector(
    higherPlanTrialInfoSelector,
    (ugTrialInfo) => ugTrialInfo.active_trial_info.trial_state === HIGHER_PLAN_TRIAL_STATE.ACTIVE
);

export const activeTrialPlanNameSelector = createSelector(
    higherPlanTrialInfoSelector,
    (ugTrialInfo) => ugTrialInfo.active_trial_info.trial_plan
);

export const lastPlanTrialDateSelector = createSelector(
    higherPlanTrialInfoSelector,
    (ugTrialInfo) => ugTrialInfo.last_trial_date
);